import { KrCard } from '@/common/card/KrCard';
import { Dashboard } from '@/common/dashboard/Dashboard';
import { Spacer, SpacerLayout } from '@/common/layout/SpacerLayout';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { McdDispBreakdownPieChart } from '@/sc/entities/mcdInv/dashboard/fin/McdDispBreakdownPieChart';
import { McdDispTrendChart } from '@/sc/entities/mcdInv/dashboard/fin/McdDispTrendChart';
import { McdFinTopCtrtCard } from '@/sc/entities/mcdInv/dashboard/fin/McdFinTopCtrtCard';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useEffect, useRef, useState } from 'react';
import { AnomalyDetectionCard } from './AnomalyDetectionCard';
import { DispTrendsCard } from './DispTrendsCard';
import { PaidTrendsCard } from './PaidTrendsCard';

export const McdFinDashboard = () => {
  const rsrc = useRsrc();

  // Filters
  const [fieldDefs, setFieldDefs] = useState();

  const defaultFormValues = useRef({
    rbtPeriodId: null,
    stateIds: null,
    ctrtIds: null,
    brandProdIds: null,
  });

  useEffect(() => {
    rsrc.data('sc', 'MCD_FIN_DASHBOARD_FILTER_DATA_PLUGIN', {}).then((res) => {
      defaultFormValues.current = {
        rbtPeriodId: res.periods[0]?.value,
        stateIds: res.stateIds,
        ctrtIds: res.ctrtIds,
        brandProdIds: res.brandProdIds,
      };
      setFieldDefs([
        { field: 'rbtPeriodId', displayName: 'Rebate Period', type: 'DROPDOWN', values: res.periods },
        { field: 'stateIds', displayName: 'States', type: 'TREE', treeData: res.stateTreeData },
        { field: 'ctrtIds', displayName: 'Contracts', type: 'TREE', treeData: res.ctrtTreeData },
        { field: 'brandProdIds', displayName: 'Brands', type: 'TREE', treeData: res.brandProdTreeData },
      ]);
    });
  }, []);

  if (!fieldDefs) {
    return null;
  }

  return (
    <Dashboard
      title="Medicaid Financial Dashboard"
      titleIcon={fas.faTasks}
      fieldDefs={fieldDefs}
      defaultFormValues={defaultFormValues.current}
    >
      {/* Main Contents */}
      {
        <SpacerLayout>
          <Spacer vertical>
            {/* Row 1 */}
            <Spacer weights={[3, 5, 5]}>
              <AnomalyDetectionCard
                defaultFormValues={defaultFormValues.current}
                dataPlugin="MCD_FIN_DASHBOARD_ANOMALIES_DATA_PLUGIN"
              />
              <PaidTrendsCard />
              <DispTrendsCard />
            </Spacer>

            {/* Row 2 */}
            <Spacer weights={[5, 3, 5]}>
              <McdFinTopCtrtCard />

              <KrCard title="Dispute Code Breakdown">
                <McdDispBreakdownPieChart />
              </KrCard>

              <KrCard title="Dispute Code Trends">
                <McdDispTrendChart />
              </KrCard>
            </Spacer>
          </Spacer>
        </SpacerLayout>
      }
    </Dashboard>
  );
};
